import { __assign, __spreadArray } from "tslib";
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import classnames from 'classnames';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { Text } from '../components/text';
import { Table } from '../components/table';
import { Button } from '../components/button';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
import { mobileFullWidthColumnClassName } from '../utils/defaults';
import { BdiWrapper } from '../components/bdi-wrapper';
export var SectionSubscribe = function (props) {
    var t = useTranslation().t;
    var _a = props.section, button = _a.button, placeholderText = _a.placeholderText, shouldRequireConsent = _a.consent.shouldRequireConsent;
    return (React.createElement(React.Fragment, null,
        React.createElement(SectionSubscribeTitle, __assign({}, props)),
        React.createElement(SectionSubscribeForm, __assign({}, props),
            React.createElement(SectionSubscribeInputForm, __assign({}, props),
                React.createElement(SectionSubscribeInput, __assign({}, props),
                    React.createElement("a", { href: button.href, style: {
                            color: '#858585',
                            height: '100%',
                            textDecoration: 'none',
                            width: '100%',
                        }, target: "_blank" },
                        React.createElement(LinkWrapper, null,
                            React.createElement(BdiWrapper, { text: placeholderText
                                    ? placeholderText
                                    : t('COMPOSER.SUBSCRIBE.ERRORS.EMAIL_PLACEHOLDER') })))),
                shouldRequireConsent && React.createElement(ConsentSection, __assign({}, props))),
            React.createElement(SectionSubscribeButton, __assign({}, props)))));
};
export var SectionSubscribeTitle = function (props) {
    var _a;
    var _b = props.section, backgroundColor = _b.backgroundColor, borderBottom = _b.borderBottom, borderLeft = _b.borderLeft, borderRight = _b.borderRight, borderTop = _b.borderTop, title = _b.title, titleCssClass = _b.titleCssClass, titleOuterPadding = _b.titleOuterPadding, titleInnerPadding = _b.titleInnerPadding, columnCssClass = props.columnCssClass, cssClass = props.cssClass, isRtl = props.isRtl;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: classnames(cssClass, titleCssClass), padding: shorthand(titleOuterPadding) },
            React.createElement(Column, { padding: shorthand(titleInnerPadding), cssClass: classnames(columnCssClass, mobileFullWidthColumnClassName) },
                React.createElement(Text, { align: isRtl ? 'right' : 'left', color: title.color, fontFamily: title.fontFamily, fontSize: title.fontSize, fontStyle: title.fontStyle, fontWeight: (_a = title.fontWeight) === null || _a === void 0 ? void 0 : _a.toString(), lineHeight: title.lineHeight + "px", padding: "0px", textDecoration: title.textDecoration },
                    React.createElement("div", { style: { width: '100%', direction: isRtl ? 'rtl' : 'ltr' } },
                        React.createElement(BdiWrapper, { text: title.text })))))));
};
export var SectionSubscribeForm = function (props) {
    var _a = props.section, backgroundColor = _a.backgroundColor, borderBottom = _a.borderBottom, borderLeft = _a.borderLeft, borderRight = _a.borderRight, borderTop = _a.borderTop, formOuterPadding = _a.formOuterPadding, formCssClass = _a.formCssClass, cssClass = props.cssClass, isRtl = props.isRtl, children = props.children;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: classnames(cssClass, formCssClass), direction: isRtl ? 'rtl' : 'ltr', padding: shorthand(formOuterPadding) }, children)));
};
export var SectionSubscribeButton = function (props) {
    var _a;
    var _b = props.section, button = _b.button, formInnerPadding = _b.formInnerPadding, columnsWidths = _b.columnsWidths, columnCssClass = props.columnCssClass, isRtl = props.isRtl, onSubscribeClick = props.onSubscribeClick;
    var height = 43;
    var buttonBorderWidth = button.border
        .split(' ')
        .map(function (e) { return parseInt(e, 10); })
        .filter(function (e) { return !isNaN(e); })
        .pop() || 0;
    var noLeftPadding = shorthand(__assign(__assign({}, formInnerPadding), { left: 0 }));
    var noRightPadding = shorthand(__assign(__assign({}, formInnerPadding), { right: 0 }));
    return (React.createElement(Column, { cssClass: classnames('html-emails-subscribe-button-container', columnCssClass, mobileFullWidthColumnClassName), direction: isRtl ? 'rtl' : 'ltr', verticalAlign: "top", width: columnsWidths[1], padding: isRtl ? noRightPadding : noLeftPadding },
        React.createElement(Button, { backgroundColor: button.backgroundColor, border: button.border, borderRadius: button.borderRadius.toString(), color: button.color, cssClass: "html-emails-subscribe-button", fontFamily: button.fontFamily, fontSize: button.fontSize, fontStyle: button.fontStyle, fontWeight: (_a = button.fontWeight) === null || _a === void 0 ? void 0 : _a.toString(), height: height - 2 * buttonBorderWidth + "px", href: button.href, innerPadding: "0 10px", padding: "0", width: "100%", textDecoration: button.textDecoration, onClick: onSubscribeClick },
            React.createElement(LinkWrapper, { fontWeight: "inherit" },
                React.createElement(BdiWrapper, { text: button.text })))));
};
export var SectionSubscribeInputForm = function (props) {
    var _a = props.section, columnsWidths = _a.columnsWidths, formInnerPadding = _a.formInnerPadding, isRtl = props.isRtl, columnCssClass = props.columnCssClass, children = props.children;
    var noLeftPadding = shorthand(__assign(__assign({}, formInnerPadding), { left: 0 }));
    var noRightPadding = shorthand(__assign(__assign({}, formInnerPadding), { right: 0 }));
    var cssClass = classnames('html-emails-subscribe-input-container', columnCssClass, mobileFullWidthColumnClassName);
    return (React.createElement(Column, { cssClass: cssClass, verticalAlign: "top", width: columnsWidths[0], padding: isRtl ? noLeftPadding : noRightPadding },
        React.createElement(Table, { padding: "0", borderCollapse: "separate" }, children)));
};
export var SectionSubscribeInput = function (props) {
    var button = props.section.button, isRtl = props.isRtl, children = props.children;
    var height = 43;
    var inputBorderWidth = 1;
    var direction = isRtl ? 'rtl' : 'ltr';
    var textAlign = isRtl ? 'right' : 'left';
    var inputBorderRadius = button.borderRadius.toString()
        ? { borderRadius: button.borderRadius.toString() }
        : {};
    return (React.createElement("tr", null,
        React.createElement("td", { colSpan: 2, style: __assign({ border: "solid " + inputBorderWidth + "px #ccc", textAlign: textAlign, fontSize: 11, backgroundColor: '#fff', paddingLeft: '20px', paddingRight: '20px', height: height - 2 * inputBorderWidth + "px", direction: direction }, inputBorderRadius) }, children)));
};
var ConsentSection = function (props) {
    var _a = props.section, _b = _a.consent, consentCheckboxText = _b.consentCheckboxText, shouldShowConsentLink = _b.shouldShowConsentLink, consentLinkText = _b.consentLinkText, consentLinkUrl = _b.consentLinkUrl, consentTextStyle = _b.consentTextStyle, href = _a.button.href, isRtl = props.isRtl;
    var direction = isRtl ? 'rtl' : 'ltr';
    var textAlign = isRtl ? 'right' : 'left';
    var fontSize = '14px';
    var textStyle = __assign(__assign({}, consentTextStyle), { textAlign: textAlign, fontSize: fontSize, lineHeight: '18px', direction: direction });
    var linkStyle = __assign(__assign({}, textStyle), { textDecoration: 'underline', marginLeft: '5px' });
    var checkboxStyle = {
        paddingLeft: '14px',
        height: '15px',
        border: 'solid 1px #d8d8d8',
        backgroundColor: '#ffffff',
        marginRight: isRtl ? '0' : '12px',
        marginLeft: isRtl ? '12px' : '0',
    };
    var commonStyle = {
        textAlign: textAlign,
        direction: direction,
        padding: "15px 0 0",
        verticalAlign: 'top',
    };
    var getColumns = function () {
        var columns = [
            React.createElement("a", { href: href, style: checkboxStyle, target: "_blank" }),
            React.createElement(React.Fragment, null,
                React.createElement("a", { style: textStyle, target: "_blank", href: href },
                    React.createElement(LinkWrapper, null,
                        React.createElement(BdiWrapper, { text: consentCheckboxText }))),
                shouldShowConsentLink && (React.createElement("a", { style: linkStyle, target: "_blank", href: consentLinkUrl },
                    React.createElement(LinkWrapper, null,
                        React.createElement(BdiWrapper, { text: consentLinkText }))))),
        ];
        return isRtl ? __spreadArray([], columns.reverse()) : __spreadArray([], columns);
    };
    return (React.createElement("tr", null,
        React.createElement("td", { style: __assign(__assign({}, commonStyle), { width: isRtl ? '100%' : 'initial' }) }, getColumns()[0]),
        React.createElement("td", { style: __assign(__assign({}, commonStyle), { width: isRtl ? 'initial' : '100%' }) }, getColumns()[1])));
};
//# sourceMappingURL=section-subscribe.js.map